import React, { Component } from 'react'
import { connect } from 'react-redux'
import { 
  Modal, Checkbox, Col, Row, Radio, ProgressBar
} from 'react-bootstrap'
import moment from 'moment'
import { DateTimePicker } from 'react-widgets'
import FileSaver from 'file-saver'

import Button from '../components/Button.jsx'
import { makeFilterTripsReport } from '../selectors'
import { mapToObject, str2date, moment2str } from '../../lib/Tools.js'
import { getStatusNames, getStatusLabel } from '../trips/TripStatus.js'
import { createReportExcelBlob } from '../../lib/xlsx.js'
import { getText } from '../lib/text.js'
import { msPromise } from '../../lib/TripTools.js'

import getPurchasesReportData from "./TripsReport.PurchasesData"
import getSalesReportData from "./TripsReport.SalesData"

/**
 *
 */

const sellsReportStyle = {
  cols: [
    {wpx: 55},
    {wpx: 150},
    {wpx: 150},
    {wpx: 210},
    {wpx: 70},
    {wpx: 100},
    {wpx: 100},
    {wpx: 100},
    {wpx: 40},
    {wpx: 40},
    {wpx: 60},
    {wpx: 80},
    {wpx: 80},
    {wpx: 80},
    {wpx: 80},
    {wpx: 80},
    {wpx: 80},
    {wpx: 100},
    {wpx: 100},
    {wpx: 100},
    {wpx: 100},
    {wpx: 100},
    {wpx: 100},
    {wpx: 300},
    {wpx: 500},
    {wpx: 100},
    {wpx: 300},
  ],
  cells: {
    "A1-X1": {
      font: { bold: true, sz: "18" },
    },
    "A2-L50000": {
      font: { sz: "14" }
    }
  }
}

const purchasesReportStyle = {
  cols: [
    {wpx: 300},
    {wpx: 150},
    {wpx: 350},
    {wpx: 75},
    {wpx: 75},
    {wpx: 75},
    {wpx: 75},
    {wpx: 75},
    {wpx: 75},
    {wpx: 75},
    {wpx: 75},
    {wpx: 75},
    {wpx: 75},
    {wpx: 75},
    {wpx: 75},
    {wpx: 150},
    {wpx: 75},
    {wpx: 75},
    {wpx: 75},
    {wpx: 75},
    {wpx: 75},
    {wpx: 100}
  ],
  cells: {
    "A1-V1": {
      font: { bold: true, sz: "18" },
    },
    "A2-L50000": {
      font: { sz: "14" }
    }
  }
}

/**
 *
 */
type TripsReportModalProps = {
  close: () => void,
  filterTripsReport: Object => Object[],
  activities: {[string]: Object},
  cities: {[string]: Object},
  reservations: {[string]: Object},
  routes: Object,
  isProduction : boolean,
}

const stateToProps = (state, props) => ({
  filterTripsReport: makeFilterTripsReport(state, props),
  isProduction: state.loginData.isProduction,
  activities: state.activities,
  cities: state.cities,
  routes: state.routes,
  reservations: state.reservations
})

const statusesIncludedDefault = new Set([
  "new", "proposal_sent", "negotiating", "contract_sent"
])

class UnconnectedTripsReportModal extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      ...(mapToObject(getStatusNames(), name => statusesIncludedDefault.has(name))),

      isAllSelected: false,
      dateFilter: true,

      // #TODO start of year rly? go back to month?
      date: moment().startOf("year").format("YYYY-MM-DD"),

      twoDatesFilter: false,
      startDate: moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
      endDate: moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD"),

      generatingReport: false,
      progressSales: { now: 0, max: 1 },
      progressPurchases: { now: 0, max: 1 },
      progressFile: { now: 0, max: 1 },
    }
  }

  props: TripsReportModalProps;

  reportProgress(key, now, max) {
    this.setState({
      generatingReport: true,
      [key]: { now, max }
    })
  }

  async downloadReport() {
    this.reportProgress("progressPurchases", 0, 1)
    this.reportProgress("progressSales", 0, 1)
    this.reportProgress("progressFile", 0, 1)

    const purchasesData = await getPurchasesReportData(
      this.props.filterTripsReport(this.state),
      this.props.routes,
      this.props.activities,
      this.props.cities,
      this.props.reservations,
      this.props.isProduction,
      (i, n) => this.reportProgress("progressPurchases", i, n)
    )

    console.log({ purchasesData })
    await msPromise(100)

    const salesData = await getSalesReportData(
      this.props.filterTripsReport(this.state),
      this.props.routes,
      this.props.activities,
      this.props.cities,
      this.props.reservations,
      this.props.isProduction,
      (i, n) => this.reportProgress("progressSales", i, n)
    )

    console.log({ salesData })

    await msPromise(100)
    this.reportProgress("progressFile", 1, 2)


    const blob = createReportExcelBlob(
      salesData, purchasesData,
      sellsReportStyle, purchasesReportStyle
    )

    await msPromise(100)

    this.reportProgress("progressFile", 2, 2)

    const date = moment2str(null, "-")

    FileSaver.saveAs(blob, `Reporte ${date}.xlsx`)
  }

  render() {
    return (
      <Modal show onHide={() => this.props.close()}>
        <Modal.Header>
          <Modal.Title>Reporte</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={6}>
              <label>Incluir clientes con estado...</label>
              <div style={{ paddingLeft: 10 }}>
                {
                  <Checkbox
                    checked={this.state.isAllSelected}
                    onChange={evt => {
                      getStatusNames().forEach(name => (name != "unk" ? this.setState({ [name]: evt.target.checked }) : ""))
                      this.setState({isAllSelected: evt.target.checked})
                    }}
                    style={{ display: "block" }}
                  >
                    <strong>Marcar/desmarcar todos</strong>
                  </Checkbox>
                }
              </div>
              <div style={{ paddingLeft: 20 }}>
                {
                  getStatusNames().filter(name => name != "unk").map(name => (
                    <Checkbox
                      key={name}
                      value={name}
                      checked={this.state[name]}
                      onChange={evt => this.setState({ [name]: evt.target.checked })}
                      style={{ display: "block" }}
                    >
                      {getStatusLabel(name)}
                    </Checkbox>
                  ))
                }
              </div>
              <div style={{ paddingLeft: 10 }}>
                {
                  <Checkbox
                    key="unk"
                    value="unk"
                    checked={this.state.unk}
                    onChange={evt => this.setState({ unk: evt.target.checked })}
                    style={{ display: "block" }}
                  >
                    {getStatusLabel("unk")}
                  </Checkbox>
                }
              </div>
            </Col>
            <Col md={6}>
              <label>Fecha (de creación)</label>

              <Radio
                style={{display:"block"}}
                checked={!this.state.dateFilter && !this.state.twoDatesFilter}
                onChange={_evt => this.setState({ dateFilter: false, twoDatesFilter: false })}
              >
                Todos
              </Radio>

              <Radio
                style={{display:"block"}}
                checked={this.state.dateFilter}
                onChange={_evt => this.setState({ dateFilter: true, twoDatesFilter: false })}
              >
                Desde esta fecha hasta hoy (incl.)
                <DateTimePicker
                  calendar
                  disabled={!this.state.dateFilter}
                  time={false}
                  format="YYYY/MM/DD"
                  value={this.state.date && str2date(this.state.date)}
                  onChange={date => {
                    this.setState({ date: moment(date).format("YYYY-MM-DD") })
                  }}
                />
              </Radio>


              <Radio
                style={{display:"block"}}
                checked={this.state.twoDatesFilter}
                onChange={_evt => this.setState({ dateFilter: false, twoDatesFilter: true })}
              >
                Entre estas dos fechas (ambas incl.)
                <DateTimePicker
                  calendar
                  disabled={!this.state.twoDatesFilter}
                  time={false}
                  format="YYYY/MM/DD"
                  value={this.state.date && str2date(this.state.startDate)}
                  onChange={date => {
                    this.setState({ startDate: moment(date).format("YYYY-MM-DD") })
                  }}
                />
                <DateTimePicker
                  calendar
                  disabled={!this.state.twoDatesFilter}
                  time={false}
                  format="YYYY/MM/DD"
                  value={this.state.date && str2date(this.state.endDate)}
                  onChange={date => {
                    this.setState({ endDate: moment(date).format("YYYY-MM-DD") })
                  }}
                />
              </Radio>

            </Col>
          </Row>

          {
            this.state.generatingReport && (
              <div>
                {
                  [this.state.progressPurchases, this.state.progressSales, this.state.progressFile]
                    .map(({now, max}, i) => {
                      const normalizedNow = Math.floor(100 * now / max)
                      const bar = ["Datos de ventas", "Datos de compras", "Fichero Excel"][i]

                      return (
                        <div key={i}>
                          <label>{bar}</label>
                          <ProgressBar
                            key={i}
                            now={normalizedNow}
                            label={`${normalizedNow}%`}
                            bsStyle={normalizedNow < 100 ? "warning" : "primary"}
                          />
                        </div>
                      )
                    })
                }
              </div>
            )
          }

        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle="primary"
            glyph="download"
            onClick={() => this.downloadReport()}
          >
            Descargar XLSX
          </Button>
          <Button
            bsStyle="success"
            glyph="ok"
            onClick={() => this.props.close()}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

const TripsReportModal = connect(stateToProps, () => ({}))(UnconnectedTripsReportModal)

/**
 *
 */

export default class TripsReportButton extends Component {
  constructor(props) {
    super(props)
    this.state = { modal: false }
  }

  render() {
    return (
      <div style={{display: "inline-block"}}>
        <Button
          glyph="download"
          onClick={() => this.setState({ modal: true })}
        >
          {getText("Descargar reporte")}
        </Button>
        {
          this.state.modal && (
            <TripsReportModal
              close={() => this.setState({ modal: false })}
            />
          )
        }
      </div>
    )
  }
}
